module.exports = __webpack_public_path__ + "static/media/x-button.3ddec927.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/x-button.svg
// module id = 816
// module chunks = 0